import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const AdditionandDeduction = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	
	const today = new Date().toISOString().split("T")[0];
	const currentMonthYear = new Date().toISOString().slice(0, 7);


	const [user, setUser] = useState({
        month_year: currentMonthYear,
		type:'all',
		pay_type:'deduct',
		reason:'',
		amount:'',
		start_date:currentMonthYear,
    
    })



	

	const [selectedMonth, setSelectedMonth] = useState(new Date());
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [shiftdataval, setshiftdataval]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);
    const [toggle,setToggle]=useState(false);

	const [appliedDept, setAppliedDept] = useState("0");
const [appliedEmployee, setAppliedEmployee] = useState("0");

	const { sortConfig, sortData, handleSort } = useSortData();

    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }



        const [empinfo, setEmpInfo] = useState({
            emp_id: "",
            shift_code: "",
            shift_date:"",
            user_id:"",
            emp_info:"",
        })
    
    
    
    
        const handelEditInput = (event) => {
            event.preventDefault();
            const { name, value } = event.target;
            console.log(name, value)
            setEmpInfo({ ...empinfo, [name]: value });
    
            // if (event.target.value === '1') {
            //     setIsVisible(true);
            //   } else {
            //     setIsVisible(false);
            //   }
        }


		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		const filteredItems = records.filter((item) => {
  const search = searchTerm.toLowerCase();

  return (
    String(item.employee_id ?? "").includes(search) ||
    String(item.employee_name ?? "").toLowerCase().includes(search) ||
    String(item.dept_name ?? "").toLowerCase().includes(search) ||
    String(item.for_reason ?? "").toLowerCase().includes(search) ||
    String(item.reason ?? "").toLowerCase().includes(search) ||
    String(item.amount ?? "").includes(search) ||
    String(item.added_date ?? "").includes(search)
  );
});
		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
		const sortedItems = sortData(filteredItems);
		const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		// const paginate = (pageNumber) => setCurrentPage(pageNumber);
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	
	 const clearInput = () => {
		setSearchTerm("");
	  };



	    const handleDepartment = async () => {
	  
			axios.get(API_BASE_URL +'/showdepartment/', { headers : {
				   'Content-Type': 'application/json',
				   Authorization: `Bearer ${localStorage.getItem("authToken")}`
		   }})
			.then(res1 => setdataval(res1.data))
			.catch(err => console.log(err))
		   };
	  
	  
		   useEffect(() => {
			handleDepartment();
		  }, []);

 const [department, setDepartmentValue] = useState("ALL");
 const [employeeDropdownOptions,setEmployeeDropdownOptions]=useState([]);
 const [employeedet,setEmployeeValue] = useState("");

 const [employeedet1, setEmployeeValue1] = useState("0");
 const [employeeDropdownOptions1,setEmployeeDropdownOptions1]=useState([]);
 const [department1, setDepartmentValue1] = useState("0");


//  const handleFirstDropdownChange = (event) => {
//     const value = event.target.value;
//     setDepartmentValue(value);

//     // Trigger API call based on the selected value
//     fetchSecondDropdownOptions(value);
//   };

const handleFirstDropdownChange = (selectedOption) => {
  const deptId = selectedOption?.value || "";

  setDepartmentValue(deptId);        // store department
  setEmployeeValue("");              // reset employee
  setEmployeeDropdownOptions([]);    // clear old employees

  if (deptId) {
    fetchSecondDropdownOptions(deptId); // fetch employees
  }
};



     // Fetch options for the second dropdown
	 const fetchSecondDropdownOptions = async (selectedValue) => {

	  try {
	  
	const response = await fetch(
		  API_BASE_URL + '/showdeptbase_all_emp/'+selectedValue, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}
		); // Replace with your API URL
  
		const data = await response.json();
		console.log(data);

		setEmployeeDropdownOptions(data); // Assuming the API returns an array of options
	  } catch (error) {
		console.error("Error fetching second dropdown options:", error);
	  }
	};


	  // Handle second dropdown change
	const handleSecondDropdownChange = (selectedOption) => {
  setEmployeeValue(selectedOption?.value || "");
};




	const handleFirstDropdownChange1 = (selectedOption) => {
  const value = selectedOption?.value || "0";

  setDepartmentValue1(value);
  setEmployeeValue1("0");           // reset employee
  setEmployeeDropdownOptions1([]);  // clear old employees

  if (value !== "0") {
    fetchSecondDropdownOptions1(value);
  }
};


     // Fetch options for the second dropdown
	 const fetchSecondDropdownOptions1 = async (selectedValue) => {

	  try {
	  
	const response = await fetch(
		  API_BASE_URL + '/showdeptbase_all_emp/'+selectedValue, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}
		); // Replace with your API URL
  
		const data = await response.json();
		console.log(data);

		setEmployeeDropdownOptions1(data); // Assuming the API returns an array of options
	  } catch (error) {
		console.error("Error fetching second dropdown options:", error);
	  }
	};


	  // Handle second dropdown change
	  const handleSecondDropdownChange1 = (selectedOption) => {
  const value = selectedOption?.value || "0";
  setEmployeeValue1(value);
};





  useEffect(()=> {
	axios.get(API_BASE_URL +'/fetchshift', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//.then(res =>console.log(res.data))
	 .then(res => setshiftdataval(res.data))
	.catch(err => console.log(err));
},[])

useEffect(() => {
  console.log("Selected month:", user.start_date);
}, [user.start_date]);




const handleSubmit = async (e) => {
  e.preventDefault();

  setCurrentPage(1);
  setSearchTerm("");
  setLoading(true);

  try {
    const response = await axios.post(
      API_BASE_URL + "/allowance_and_deduction",
      {
        month_year: user.start_date,
        dept_id: department1,
        employee_id: employeedet1,
        action_type: user.type,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      }
    );

    setRecords(response.data.allowance_deduction_list || []);
  } catch (error) {
    console.error(error);
    setRecords([]);
  } finally {
    setLoading(false);
  }
};


 

const handleAddSubmit = (e) => {

    e.preventDefault();

	// alert(employeedet);

    axios.post(API_BASE_URL + '/addOtherAllowanceDeduction', {dept_id: department,employee_id: employeedet,pay_month: user.month_year,pay_type:user.pay_type, reason: user.reason,amount:user.amount }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    }).then(response => {
        // console.log(response.data);
        // // 	console.log(response.data.message);
        //  })

		// console.log(response.data);

        var status = response.data.status;

        if (status == 200) {
            toast.success(response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",

            });

            const timeout = setTimeout(() => {
                window.location.reload(); // Reload the current page
            }, 5000); // Refresh after 5 seconds

            return () => {
                clearTimeout(timeout); // Cleanup the timeout if the component unmounts
            };

        } else if (status == 401) {
            toast.error(response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",

            });
        }
        else if (status == 400) {
            toast.error(response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",

            });
        }


    }).catch(error => {
        // console.log(error);
        // console.log(error.response.data.message);




        toast.error(error.response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",


        });

    });
};




const allOptions = [
  { value: "", label: "All Department" },
  ...dataval.map(option => ({
    value: String(option.department_id),
    label: option.department_name
  }))
];


 const options = [
//   { value: "ALL", label: "All Employee" },
  ...employeeDropdownOptions.map(option => ({
    value: option.employee_id,
    label: `${option.first_name} ${option.last_name} (${option.employee_id})`
  }))
];


const employeeOptions1 = [
  { value: "0", label: "Select Employee" },
  ...employeeDropdownOptions1.map(emp => ({
    value: String(emp.employee_id),
    label: `${emp.first_name} ${emp.last_name} (${emp.employee_id})`
  }))
];





 

const columns = [
	{ label: "Employee Id", key: "employee_id", sortable: true },
	{ label: "Employee Name", key: "employee_name", sortable: true },
	{ label: "Department Name", key: "dept_name", sortable: true },
  { label: "Reason", key: "for_reason", sortable: true },
  { label: "Type", key: "reason", sortable: true },
  { label: "Amount", key: "amount", sortable: true },
  { label: "Added on", key: "added_date", sortable: true }
];

	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
						
						</div>
					</div>

		<div className="section-body mb-4">
		<Link to={`/Addallowance-deduction`}>
        <button className="btn btn-primary me-2" >
          Manage Allowance
        </button>
		</Link>

		<Link to={`/Import-Allowance`}>
        <button className="btn btn-light me-2" >
          Import Allowance
        </button>
		  </Link>

		<Link to={`/Import-Deduction`}>
        <button className="btn btn-light" >
          Import Deduction
        </button>
		  </Link>
      </div>
	


					<div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
													<div className="card">
														{/* <div className="card-header">
															<h3 className="card-title">My Shift</h3>
														</div> */}

														
														<div className="card-body" style={{ padding: '5px' }}>
															
														{/* <h3 className="card-title" style={{color:'#e96827'}}>ADD Other Allowance & Deduction</h3> */}
														 
														 <button style={{width:'100px',float: 'right',margin: '10px 35px 15px 10px'}}
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={()=>setToggle(!toggle)}
                                                        >
                                                            <i className="fe fe-plus mr-2" />
                                                            Add
                                                        </button>
                                                        {toggle && (
														
													<div className="card">
														{/* <div className="card-header">
															<h3 className="card-title">My Shift</h3>
														</div> */}
														<div className="card-body">

                                                      

														    	<hr />
                                                       


															 <form onSubmit={handleAddSubmit} > 
					
																<div class="row">
					
																<div className="col-md-4 col-sm-4">
															<div className="form-group">
															
															<label className="form-label">Department<span className="form-required">*</span></label>
															{/* <select className="form-control show-tick" name="department"  isSearchable={true} // Enable search
														placeholder="Select a fruit..." value={department}  onChange={handleFirstDropdownChange}>
															<option value="ALL">All Department</option>
																{dataval.map(option => (
																<option key={option.department_id} value={option.department_id}>
																{option.department_name}
																</option>
																))}
														</select> */}

														<Select
															name="department"
															value={
																department
																	? allOptions.find(opt => opt.value === department)
																	: null
															}
															onChange={handleFirstDropdownChange}
															options={allOptions}
															isSearchable={true}
															placeholder="All Department"
															  styles={{
														  control: (base) => ({
															...base,
															minHeight: "28px",
															height: "28px",
															borderRadius: "4px",
															borderColor: "#ced4da",
															boxShadow: "none",
															fontSize: "12px",
															padding: "0 4px",
															"&:hover": { borderColor: "#b3b3b3" }
														  }),
														
														  valueContainer: (base) => ({
															...base,
															height: "28px",
															padding: "0 6px",
														  }),
														
														  input: (base) => ({
															...base,
															margin: "0px",
															padding: "0px"
														  }),
														
														  indicatorsContainer: (base) => ({
															...base,
															height: "28px"
														  }),
														
														  menu: (base) => ({
															...base,
															borderRadius: "4px",
															zIndex: 9999
														  }),
														
														  option: (base, state) => ({
															...base,
															fontSize: "12px",
															padding: "6px 10px",
															backgroundColor: state.isFocused ? "#f8f9fa" : "white",
															color: "#333"
														  })
														}}
														classNamePrefix="react-select"
														/>

														
																
															</div>
														</div>



														<div className="col-md-4 col-sm-4">
															<div className="form-group">
															<label className="form-label">Employee<span className="form-required">*</span></label>
															{/* <select className="form-control show-tick"
														value={employeedet} name="employeedet"
														onChange={handleSecondDropdownChange}
														disabled={employeeDropdownOptions.length === 0}
														>
														<option value="">Select Employee</option>
														{employeeDropdownOptions.map((option) => (
															<option key={option.employee_id} value={option.employee_id}>
															{option.first_name} {option.last_name} ({option.employee_id})
															</option>
														))}
														</select> */}

																								<Select
  name="employeedet"
  options={options}
  isSearchable={true}
  placeholder="Select Employee"
  value={options.find(opt => opt.value === employeedet) || null}
  onChange={handleSecondDropdownChange}
  isDisabled={employeeDropdownOptions.length === 0}
  styles={{
    control: (base) => ({
      ...base,
      minHeight: "28px",
      height: "28px",
      borderRadius: "4px",
      borderColor: "#ced4da",
      boxShadow: "none",
      fontSize: "12px",
      padding: "0 4px",
      "&:hover": { borderColor: "#b3b3b3" }
    }),

    valueContainer: (base) => ({
      ...base,
      height: "28px",
      padding: "0 6px",
    }),

    input: (base) => ({
      ...base,
      margin: "0px",
      padding: "0px"
    }),

    indicatorsContainer: (base) => ({
      ...base,
      height: "28px"
    }),

    menu: (base) => ({
      ...base,
      borderRadius: "4px",
      zIndex: 9999
    }),

    option: (base, state) => ({
      ...base,
      fontSize: "12px",
      padding: "6px 10px",
      backgroundColor: state.isFocused ? "#f8f9fa" : "white",
      color: "#333"
    })
  }}
  classNamePrefix="react-select"
/>
	</div>
															</div>
														


														<div className="col-md-4 col-sm-4">
																	<div className="form-group">
																	<label className="form-label">Select Month<span className="form-required">*</span></label>
																	<input type="month" className="form-control" name="month_year" value={user.month_year}
													onChange={handelInput} placeholder="Start Date"/>
																
																	</div>
																</div>


														<div className="col-md-4 col-sm-4">
															<div className="form-group">
																<label className="form-label">Type<span className="form-required">*</span></label>
																<select className="form-control show-tick" name="pay_type" value={user.pay_type} onChange={handelInput}>
																{/* <option value="">All</option> */}
																<option value="deduct">Deduction</option>
																<option value="add">Addition</option>
																</select>
															</div>
														</div>


														<div className="col-md-4 col-sm-4">
															<div className="form-group">
															<label className="form-label">Reason<span className="form-required">*</span></label>

															<input class="form-control" placeholder="" name="reason" type="text" value={user.reason} onChange={handelInput} />
														</div>
													</div>

													<div className="col-md-4 col-sm-4">
															<div className="form-group">
															<label className="form-label">Amount<span className="form-required">*</span></label>

															<input class="form-control" placeholder="" name="amount" type="text" value={user.amount} onChange={handelInput} />
														</div>
													</div>
					
														
														
												
					
													
													
					
					
													<div className="col-md-4 col-sm-6">
														<div className="form-group">
					
													<button type="submit" className="btn btn-primary">
													Submit
												</button>
					
												
												</div>
												</div>
					
					
					
												{/* <div className="col-md-2 col-sm-6">
														<div className="form-group">
					
												   
					
												<Link to={`/attendancecalendar`} className="btn btn-primary">Attendance Calendar</Link>
					
												</div>
												</div> */}
					
					
												</div>
					
												
												   
					
															   
					
					
															
						
															
																
															 </form>

                                               
														</div>
													</div>
                                                     )}

														</div>
													</div>
												</div>
					
											</div>
										</div>
									</div>


					 <div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
													<div className="card">
														{/* <div className="card-header">
															<h3 className="card-title">My Shift</h3>
														</div> */}
														<div className="card-body">
															 <form onSubmit={handleSubmit} > 
					
																<div class="row">
					
													<div className="col-md-3 col-sm-3">
															<div className="form-group">
															
															<label className="form-label">Department</label>
															{/* <select className="form-control show-tick" name="department"  isSearchable={true} // Enable search
														placeholder="Select a fruit..." value={department1}  onChange={handleFirstDropdownChange1}>
															<option value="0">All Department</option>
																{dataval.map(option => (
																<option key={option.department_id} value={option.department_id}>
																{option.department_name}
																</option>
																))}
														</select> */}


														<Select
															name="department"
															value={
																department1
																	? allOptions.find(opt => opt.value === department1)
																	: null
															}
															onChange={handleFirstDropdownChange1}
															options={allOptions}
															isSearchable={true}
															placeholder="All Department"
															  styles={{
														  control: (base) => ({
															...base,
															minHeight: "28px",
															height: "28px",
															borderRadius: "4px",
															borderColor: "#ced4da",
															boxShadow: "none",
															fontSize: "12px",
															padding: "0 4px",
															"&:hover": { borderColor: "#b3b3b3" }
														  }),
														
														  valueContainer: (base) => ({
															...base,
															height: "28px",
															padding: "0 6px",
														  }),
														
														  input: (base) => ({
															...base,
															margin: "0px",
															padding: "0px"
														  }),
														
														  indicatorsContainer: (base) => ({
															...base,
															height: "28px"
														  }),
														
														  menu: (base) => ({
															...base,
															borderRadius: "4px",
															zIndex: 9999
														  }),
														
														  option: (base, state) => ({
															...base,
															fontSize: "12px",
															padding: "6px 10px",
															backgroundColor: state.isFocused ? "#f8f9fa" : "white",
															color: "#333"
														  })
														}}
														classNamePrefix="react-select"
														/>
																
															</div>
														</div>



														<div className="col-md-3 col-sm-3">
															<div className="form-group">
															<label className="form-label">Employee</label>
															{/* <select
  className="form-control show-tick"
  value={employeedet1}
  name="employee_id"
  onChange={(e) => setEmployeeValue1(e.target.value)}
  disabled={employeeDropdownOptions1.length === 0}
>

														<option value="0">Select Employee</option>
														{employeeDropdownOptions1.map((option) => (
															<option key={option.employee_id} value={option.employee_id}>
															{option.first_name} {option.last_name}
															</option>
														))}
														</select> */}

														<Select
  name="employee_id"
  options={employeeOptions1}
  isSearchable={true}
  placeholder="Select Employee"
  value={
    employeeOptions1.find(opt => opt.value === employeedet1) || null
  }
  onChange={handleSecondDropdownChange1}
  isDisabled={employeeDropdownOptions1.length === 0}
  styles={{
    control: (base) => ({
      ...base,
      minHeight: "28px",
      height: "28px",
      borderRadius: "4px",
      borderColor: "#ced4da",
      boxShadow: "none",
      fontSize: "12px",
      padding: "0 4px",
      "&:hover": { borderColor: "#b3b3b3" }
    }),
    valueContainer: (base) => ({
      ...base,
      height: "28px",
      padding: "0 6px",
    }),
    input: (base) => ({
      ...base,
      margin: "0px",
      padding: "0px"
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "28px"
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "4px",
      zIndex: 9999
    }),
    option: (base, state) => ({
      ...base,
      fontSize: "12px",
      padding: "6px 10px",
      backgroundColor: state.isFocused ? "#f8f9fa" : "white",
      color: "#333"
    })
  }}
  classNamePrefix="react-select"
/>

															</div>
														</div>


														<div className="col-md-2 col-sm-2">
																	<div className="form-group">
																	<label className="form-label">Select Month</label>
																	<input
  type="month"
  className="form-control"
  name="start_date"
  value={user.start_date}
  onChange={handelInput}
  placeholder="Start Date"
/>

																
																	</div>
																</div>


														<div className="col-md-2 col-sm-2">
															<div className="form-group">
																<label className="form-label">Type</label>
																<select className="form-control show-tick" name="type" value={user.type} onChange={handelInput}>
																<option value="all">All</option>
																<option value="deduct">Deduction</option>
																<option value="add">Addition</option>
																</select>
															</div>
														</div>
					
														
														
												
					
													
													
					
					
													<div className="col-md-2 col-sm-2">
														<div className="form-group">
														
													<label><br /><br /></label>
													<button type="submit" className="btn btn-primary">
													GET
												</button>
					
												
												</div>
												</div>
					
					
					
												{/* <div className="col-md-2 col-sm-6">
														<div className="form-group">
					
												   
					
												<Link to={`/attendancecalendar`} className="btn btn-primary">Attendance Calendar</Link>
					
												</div>
												</div> */}
					
					
												</div>
					
												
												   
					
															   
					
					
															
						
															
																
															 </form>
														</div>
													</div>
												</div>
					
											</div>
										</div>
									</div>


										<div className="section-body">
											<div className="container-fluid">
												<div className="tab-content">
													<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
														<div className="card">
					
															<div className="card-header">
																<h3 className="card-title" style={{color:'#e96827'}}>Payment Info</h3>
																<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
															</div>
					
															{/* <div>
																<DataTable 
																columns={column} 
																data={data}
																customStyles={customStyles}
																pagination 
																highlightOnHover
																responsive
																paginationPerPage={10}
																paginationRowsPerPageOptions={[25,50,100,500]}
																className="table table-striped table-bordered"> 
															</DataTable>
															</div> */}
					
					
					
					
					
					
					
					{/* Loading Spinner */}
					{loading && (
																<div className="card-body">
																<div class="d-flex justify-content-center">
						   <div class="spinner"></div>
						   </div>
						   </div>
						  )}
					
					{!loading && (
															<div className="card-body">
															
																<div className="table-responsive">
							
					
						
						  
								<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
																		<thead>
																			<tr>
                                                                                
																			    {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}
																				
																				
																			</tr>
																		</thead>
																		<tbody>
																		{filteredData.length > 0 ? (
																				filteredData.map((record) => {

                                                                                
                                                               return(



																					<tr key={`${record.employee_id}-${record.added_date}`}>
                                                                                  
																					<td>{record.employee_id}</td>
																					<td>{record.employee_name}</td>
																					<td>{record.dept_name}</td>
																					<td>{record.for_reason}</td>
																					<td>{ReactHtmlParser(record.reason)}</td>
																					<td>{record.amount}</td>
																					<td>{record.added_date}</td>
																					
																				</tr>
                                                               )
})
																			) : (
																				<tr>
																				<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
																				</tr>
																			)}
					
																
																		</tbody>
																	</table>
																</div>
															
												<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>		
													
					
															</div> 
					)
					}
														</div>
													</div>
						
												
												</div>
											</div>
										</div>

				</div>
			</div>



            




		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(AdditionandDeduction);